import {signal} from "@preact/signals-react";

export const marketplacesOffersDetailsIsEmpty = signal(false)

export const resetMarketplacesOffersDetailsSignals = () => {
    marketplacesOffersDetailsIsEmpty.value = false
}